import { DropdownOptionType } from '@Components/Dropdown/Type';
import { postFedExDetails } from '@Reducers/AdminShipment/actions';
import { AppDispatch } from '@Store';

export const PaymentTypeOptions: DropdownOptionType[] = [
  { value: 'COD', display: 'COD' },
  { value: 'Cash', display: 'Cash' },
  { value: 'Acc/Prepaid', display: 'Acc/Prepaid' },
];

export const DutyTypeOptions: DropdownOptionType[] = [
  { value: 'DDP', display: 'DDP' },
  { value: 'DDU', display: 'DDU' },
];

export interface linexInformationSchema {
  csp: string;
  type: string;
  accountNo: string;
  dutyType: string;
  PaymentType: string;
  content: string;
}

export const onForward = async ({
  values,
  shipmentNumber,
  dispatch,
  nextFunc,
  setLoading,
}: {
  values: linexInformationSchema;
  shipmentNumber: string;
  dispatch: AppDispatch;
  nextFunc: () => void;
  setLoading: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  try {
    setLoading(true);

    const body: any = { ...JSON.parse(JSON.stringify(values)) };
    body.csp = 'linex';

    for (const key in body) {
      if (body[key]) {
        if (key === 'accountNo') {
          if (Array.isArray(body[key])) {
            body[key] = body[key][0]?.value?.split('-')?.[0] || '';
          } else if (typeof body[key] === 'object' && body[key]?.value) {
            body[key] = body[key].value.split('-')?.[0] || '';
          } else if (typeof body[key] === 'string') {
            body[key] = body[key].split('-')?.[0];
          }
        }
      }
    }

    const response: any = await dispatch(
      postFedExDetails({
        shipmentNumber: `${shipmentNumber}`,
        body,
        date: null,
        nextFunc,
      }),
    );

    // call nextFunc only when success
    if (response.meta.requestStatus === 'fulfilled') {
      nextFunc();
    }
  } catch (error) {
    console.error('Error in onForward:', error);
  } finally {
    setLoading(false);
  }
};
